import styled from 'styled-components'
import { layout } from '../../../styles/GlobalVariables'

export const ScriptWrapper = styled.div`
  display: flex;
  margin-bottom: ${layout.gridBlockGap};

  #terrific-timeline-div {
    flex: 100%;
    max-height: 80dvh;
  }
`
